import { render, staticRenderFns } from "./EwaLiveWell.vue?vue&type=template&id=bf159876"
import script from "./EwaLiveWell.vue?vue&type=script&lang=js"
export * from "./EwaLiveWell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports